import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

console.log('Supabase config:', {
  url: supabaseUrl ? `${supabaseUrl.substring(0, 20)}...` : 'missing',
  anonKey: supabaseAnonKey ? `${supabaseAnonKey.substring(0, 10)}...` : 'missing'
});

export const supabase = createClient(supabaseUrl, supabaseAnonKey); 